import { DateTime } from "luxon";
import { cents, centsToDollars } from "byzantine";
import Filters from "byzantine/src/filters";

export const formatCurrencyFromCents = (amountCents: number): string =>
  Filters.currency(centsToDollars(cents(amountCents)), { hasDecimal: true });

export const formatDate = (iso: string): string =>
  DateTime.fromISO(iso).toFormat("MM/dd/yyyy");

export const formatEffectiveDateRange = (
  fileSummary: API.ACHPassthrough.FileSummary
): string | null => {
  if (!fileSummary.earliest_effective_date) return null;
  if (
    !fileSummary.latest_effective_date ||
    fileSummary.latest_effective_date === fileSummary.earliest_effective_date
  ) {
    return formatDate(fileSummary.earliest_effective_date);
  }
  return `${formatDate(fileSummary.earliest_effective_date)} - ${formatDate(fileSummary.latest_effective_date)}`;
};
